import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { sortComplimentaryProductsByPrice } from 'pages/common/helpers/sort-complimentary-products-by-price';

export const getCheapestProduct = (products: TComplimentaryProductInfo[]): TComplimentaryProductInfo =>
  sortComplimentaryProductsByPrice(products)[0];
